import { CSSProperties } from 'react';
import AccountCheckbox from './AccountCheckbox';

interface Props {
  label: string;
  onToggle?: (isChecked: boolean) => void;
  isChecked: boolean;
  checkColor: string;
  style?: CSSProperties;
}

export const AccountToggle = ({
  label,
  onToggle,
  isChecked,
  checkColor = '#f1f1f1',
  style,
}: Props) => {
  const isEnabled = onToggle !== undefined;
  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', ...style }}>
        <p style={{ margin: 0 }}>{label}</p>
        <AccountCheckbox
          onClick={isEnabled ? () => onToggle(!isChecked) : undefined}
          showCheck={isChecked}
          checkColor={checkColor}
          style={{
            marginLeft: 6,
            // Disabled cursor without a callback.
            cursor: isEnabled ? undefined : 'not-allowed',
          }}
          key={label}
        />
      </div>
    </>
  );
};
